<template>
  <DefaultLayout>
    <div slot="content">
      <div class="title py-3">Default SMS Templates</div>
      <v-divider></v-divider>
      <v-data-table :headers="smsTemplateHeaders" :loading="dataLoading" :items="smsTemplates" hide-default-footer>
        <template v-slot:item.id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text icon color="green" @click="editSmsTemplate(item)"><v-icon>edit</v-icon></v-btn>
            </template>
            <span>Edit SMS Template</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-dialog v-model="updateSmsDialog" width="400">
        <v-card>
          <v-card-title class="blue-grey white--text">Edit SMS Template</v-card-title>
          <v-card-text>
            <v-form ref="editSmsTemplateForm">
              <v-text-field v-model="sender" label="Sender" type="text" :rules="smsSenderRules"></v-text-field>
              <v-textarea rows="4" v-model="body" label="Body" type="text" :rules="[v => !!v || '']"></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="updateSmsDialog = false">Close</v-btn>
            <v-btn tile dark depressed color="blue" @click="saveSmsTemplate">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </DefaultLayout>
</template>

<script>
import { GET_DEFAULT_SMS_TEMPLATES, UPDATE_DEFAULT_SMS_TEMPLATE } from '@/store/actions.type';
import DefaultLayout from '@/layouts/DefaultLayout';

export default {
  name: 'sms-templates',
  components: {
    DefaultLayout,
  },
  data() {
    return {
      dataLoading: false,
      updateSmsDialog: false,
      smsTemplateHeaders: [
        { text: 'Type', value: 'typeString', align: 'left' },
        { text: 'Actions', value: 'id', align: 'left', sortable: false },
      ],
      smsTemplates: [],
      id: '',
      sender: '',
      body: '',
    };
  },
  computed: {
    smsSenderRules() {
      const required = v => !!v || 'Sender is required';
      const length = v => v.length < 12 || 'Max length 11 symbols';
      const symbolsRegExp = /^[\w]*$/;
      const symbols = v => symbolsRegExp.test(String(v).toLowerCase()) || 'Please check the sender name';
      return [required, length, symbols];
    },
  },
  methods: {
    async getSmsTemplates() {
      this.dataLoading = true;
      try {
        const response = await this.$store.dispatch(GET_DEFAULT_SMS_TEMPLATES);
        this.smsTemplates = response.list;
        this.dataLoading = false;
        this.smsTemplates.forEach(el => {
          switch (el.type) {
            case 1:
              el.typeString = "AppUserInvite"
              break;
            case 2:
              el.typeString = "NewProfileRequest"
              break;
            case 3:
              el.typeString = "AppUserInviteReminder"
              break;
            case 4:
              el.typeString = "NewProfileRequestReminder"
              break;
            case 5:
              el.typeString = "AuthenticatorCode"
              break;
            case 6:
              el.typeString = "NewAnonymousProfileRequest"
              break;
          }
        });
      } catch(error) {
        this.$notify({
          type: 'error',
          title: 'Error!',
          text: 'Error getting SMS templates. Please contact support@planetverify.com',
        });
        this.dataLoading = false;
      }
    },
    async saveSmsTemplate() {
      if (this.$refs.editSmsTemplateForm.validate()) {
        const smsTemplate = {
          id: this.id,
          sender: this.sender,
          body: this.body,
        };
        try {
          await this.$store.dispatch(UPDATE_DEFAULT_SMS_TEMPLATE, smsTemplate);
          this.$notify({
            type: 'success',
            title: 'Success',
            text: 'SMS Template Updated',
          });
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error!',
            text: 'Error updating SMS template. Please contact support@planetverify.com',
          });
        }
        await this.getSmsTemplates();
        this.updateSmsDialog = false;
      }
    },
    editSmsTemplate(template) {
      this.id = template.id;
      this.sender = template.sender;
      this.body = template.body;
      this.updateSmsDialog = true;
    },
  },
  async mounted() {
    await this.getSmsTemplates();
  },
}
</script>
